import { environment } from './../../../../environments/environment';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { StepsComponent } from '../steps/steps.component';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { RouterModule } from '@angular/router';
import { SectionsService } from '../../../services/sections.service';
import { StepInfo } from '../../../interfaces/referralSections.interface';
import { ButtonComponent } from '@ppl/ui';
import { RoutingService } from '../../../shared/services/routing.service';
import {
  ENROLLMENT_TITLE_MAPPINGS,
  ENROLLMENT_TYPE_BACKEND_MAPPINGS,
  ENROLLMENT_TYPE_MAPPINGS,
  FLOW_MAPPINGS,
} from '../../../shared/constants/static-data.constants';
import { ReferralDataService } from '../../../services/referral-data.service';
import { PopupDialogComponent } from '@ppl/ui';
import { ListService } from '../../../shared/services/list.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FlowDialogComponent } from '../../../shared/components/flow-dialog/flow-dialog.component';
import { NewEnrollmentComponent } from '../new-enrollment/new-enrollment.component';
import { ParticipantInformationComponent } from '../participant-information/participant-information.component';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { BaseComponent } from '../../../shared/utils/base.component';

@Component({
  selector: 'ppl-new-referral',
  standalone: true,
  imports: [
    StepsComponent,
    NzGridModule,
    RouterModule,
    ButtonComponent,
    PopupDialogComponent,
    NzIconModule,
  ],
  providers: [ListService],
  templateUrl: './new-referral.component.html',
  styleUrl: './new-referral.component.css',
})
export class NewReferralComponent
  extends BaseComponent
  implements OnInit {
  currentStep = 0;
  steps: StepInfo[] = [];
  flow: any = '';
  id: any;
  show = false;
  showTrackingInfo = false;
  trackingNumber: any;
  providerPPLId: any;
  participantPPLId: any;
  isApproved = false;
  pplId: any;
  showAssociation = false;
  currentFlow: any;
  selectedId: any;
  program: any;
  identifier: any[] = [];
  formReadonly = false;

  @ViewChild('wizContainer') wizContainer?: ElementRef;

  constructor(
    private router: RoutingService,
    private sectionsService: SectionsService,
    private referralDataService: ReferralDataService,
    private listService: ListService,
    private notificationService: NotificationService,
    private sectionService: SectionsService,
    private leadDetailsService: LeadDetailsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.flow = this.sectionsService.getFlow();
    this.selectedId = localStorage.getItem('selected_lead');
    this.program = JSON.parse(localStorage.getItem('selected_program')!);
    this.referralDataService.flowForAssociation.subscribe((data: any) => {
      this.showAssociation = data.val;
      this.currentFlow = this.getEnrollmentType(data.flow);
      this.formReadonly = this.referralDataService.getAssociationsEditable();

    });
  }

  closePopup() {
    this.sectionService.setFlow('participantEnrollment');
    this.referralDataService.setFlowForAssociation({
      val: false,
      flow: 'participantEnrollment',
    });
    this.referralDataService.clearAssociationsFormData();
  }

  generateProviderAssociationPayload(filledData: any) {
    console.log('Final data', filledData);
    const participantId = localStorage.getItem('participantId');

    return {
      participantId: participantId,
      programCode: this.program.program_code,
      pageType: "participantAssociation",
      infoData: this.generateInfoDataPayload(filledData),
      ...(filledData.contactDetailsData && {
        communicationData: this.generateCommunicationDataPayload(filledData),
      }),
      ...(filledData.contactDetailsData && {
        contactDetails: this.generateContactDataPayload(filledData),
      }),
      ...(filledData.serviceDetailsData && {
        serviceDetails: this.generateServiceDataPayload(filledData),
      }),
    };
  }

  generateInfoDataPayload(filledData: any) {
    const providerType = Object.keys(ENROLLMENT_TYPE_BACKEND_MAPPINGS).find(
      (keyVal) => ENROLLMENT_TYPE_BACKEND_MAPPINGS[keyVal] == this.currentFlow
    );
    return {
      ...filledData.infoData,
      providerType: providerType,
      providerId: 0,
      // applicationStatus: 'In Progress',
      finalApplicantDisposition: 'Enrollment',
      programCode: this.program.program_code,
      identifiers: [
        {
          type: 'SSN',
          value: filledData.infoData.SSN,
        },
        {
          type: 'MCD_ID',
          value: filledData.infoData.MCD_ID,
        },
        {
          type: 'EIN',
          value: filledData.infoData.EIN,
        },
        {
          type: 'NPI',
          value: filledData.infoData.NPI,
        },
      ],
      nprftDocumentationReceived: filledData?.commPreferencesData?.nprftDocumentationReceived,
      taxExempt: filledData?.commPreferencesData?.taxExempt
    };
  }

  generateContactDataPayload(filledData: any) {
    const {
      emergencyContactFirstName,
      emergencyContactLastName,
      emergencyContactPhone,
    } = filledData.commPreferencesData;

    return {
      providerId: 0,
      programCode: this.program.program_code,
      emergencyContactFirstName,
      emergencyContactLastName,
      emergencyContactPhone,
      ...filledData.contactDetailsData
    };
  }

  generateCommunicationDataPayload(filledData: any) {
    const { permanentAddress, email, altPhone, mobile } = filledData.contactDetailsData;

    // Initialize the contactMethods array with email and mobile entries
    const contactMethods = [
        {
            providerId: 0,
            programCode: this.program.program_code,
            contactMethod: "email",
            value: email
        },
        {
            providerId: 0,
            programCode: this.program.program_code,
            contactMethod: "mobile",
            value: mobile
        }
    ];

    // Conditionally add altPhone if it is not null or an empty string
    if (altPhone) {
        contactMethods.push({
            providerId: 0,
            programCode: this.program.program_code,
            contactMethod: "altPhone",
            value: altPhone
        });
    }

    return {
            permanentAddress: {
                providerId: 0,
                programCode: this.program.program_code,
                ...permanentAddress
            },
            contactMethods: contactMethods,
            ...filledData.commPreferencesData
        }
  }

  generateServiceDataPayload(filledData: any) {
    const { profLicences, servicesRendered, ...restServiceData } = filledData.serviceDetailsData;
    const profLicencesMOdified = profLicences && profLicences.map((license: string) => ({ licenseType: license }));
    const servicesRenderedModified = servicesRendered && servicesRendered.map((service: string) => ({ serviceType: service }));
    return {
      providerId: 0,
      programCode: this.program.program_code,
      profLicences: profLicencesMOdified,
      servicesRendered: servicesRenderedModified,
      ...restServiceData
    };
  }

  onClose() {
    this.show = false;
    this.referralDataService.clearReferrralData();
    this.goBack();
  }

  showConfirmation(data: any) {
    this.show = true;
    this.trackingNumber = data.trackingNumber;
    this.id = data.id;
    this.isApproved = data.isApproved;
    this.pplId = data.pplId;
  }

  showTrackingInformation(data: any) {
    this.showTrackingInfo = true;
    this.trackingNumber = data.trackingNumber != "null" ? data.trackingNumber : "";
    this.providerPPLId = data.providerPPLId != "null" ? data.providerPPLId : "";
    this.participantPPLId = data.participantPPLId != "null" ? data.participantPPLId : "";
  }

  stepSelected(step: StepInfo) {
    // if (this.flow == 'newEnrollment') {
    //   this.router.navigate(`/home/newEnrollment/${step.step_id}`);
    // } else {
    this.router.navigate(`/newReferral/${step.step_id}`);
    // }

    if (this.wizContainer) {
      this.wizContainer.nativeElement.scrollTop = 0;
    }
  }

  getTitle(): string {
    if (this.flow === 'providerEnrollment') {
      const enrollmentTypes = this.sectionService.getEnrollmentType();
      if (enrollmentTypes.length > 1) {
        return 'Associations';
      }

      return FLOW_MAPPINGS[enrollmentTypes[0]];
    }
    const type = this.flow;
    return FLOW_MAPPINGS[type] || type;
  }

  getEnrollmentPageTitle(flow: string): string {
    return ENROLLMENT_TITLE_MAPPINGS[flow] || flow;
  }

  getEnrollmentType(flow: string): string {
    return ENROLLMENT_TYPE_MAPPINGS[flow] || flow;
  }

  returnClicked(): void {
    this.referralDataService.clearReferrralData();
    this.goBack();
  }

  goBack() {
    let path;

    if (this.flow == 'participants') {
      path = `/`;
    } else if (this.flow == 'providers') {
      path = `/`;
    } else if (this.flow == 'referral') {
      path = `/`;
    } else if (this.flow == 'participantEnrollment') {
      path = `/`;
    } else {
      path = `/`;
    }
    this.router.navigate(path);
  }
}
